import { wrap, wrapGql } from "../_"

const pfx = "/partner"

export default (a: NuxtAxiosInstance) => ({
  // getPartners: (cfg?: AxiosConfig) => wrap(
  //   a.$get(`${pfx}`,
  //     { cache: true, ...cfg })),

  getPartners: (cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listPartner(
            limit: 999
            sorters: [{ name: "position", order: ASC }]
          ) {
            items {
              id
              title {
                current
              }
              status {
                current
              }
              # Поле, по которому сортируем, должно быть в выборке
              position
              groups {
                id
              }
              logoRu {
                url
              }
              logoEn {
                url
              }
              siteUrl {
                current
              }
            }
          }
        }
      `,
    }, cfg),
  ),

  getPartnerData: (partnerAlias: string, cfg?: AxiosConfig) => wrap(
    a.$get(`${pfx}/${partnerAlias}`,
      { cache: true, ...cfg })),

  getPartnersGroups: (cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listPartnerGroup(
            limit: 999
            filters: [{ name: "frontDisplay.visible", value: true }]
            sorters: [{ name: "frontDisplay.position", order: ASC }]
          ) {
            items {
              id
              title {
                current
              }
              # Поля, по которым фильтруем и сортируем, должны быть в выборке
              frontDisplay {
                visible
                position
              }
            }
          }
        }
      `,
    }, cfg),
  ),
})
